module.exports = __webpack_public_path__ + "img/japan.74bdf362.svg";